import "./App.css";
import "@fontsource/roboto";
import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import FormContainer from "./components/formContainer";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<FormContainer />}></Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
